import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import 'rxjs';

import { Subject } from "rxjs";
import * as moment from 'moment';
import { Moment } from "moment";
@Injectable()

export class EmailSmsHelperUtils {

    //variable option field
    VARIABLE_FIELD = [{
        label: 'Client',
        options: [{
            name: 'First Name',
            value: '%fname%'
        }, {
            name: 'Last Name',
            value: '%lname%'
        }, {
            name: 'Phone',
            value: '%phone%'
        }, {
            name: 'Email',
            value: '%email%'
        }, {
        }]
    }, {
        label: 'Appointment',
        options: [{
            name: 'Type',
            value: '%atype%'
        }, {
            name: 'Duration',
            value: '%duration%'
        }, {
            name: 'Price',
            value: '%price%'
        }, {
            name: 'Date and Time',
            value: '%datetime%'
        }, {
            name: 'Office',
            value: '%office%'
        }, {
            name: 'Scheduling Link',
            value: '%slink%'
        }]
    }]

    //Button fields
    BUTTON_FIELDS = [{
        name:'Add to iCal / Outlook Calendar',
        value:'outlook'
    },{
        name:'Add to Google Calendar',
        value:'google'
    },{
        name:'Reschedule Appointment',
        value:'reschedule'
    },{
        name:'Cancel Appointment',
        value:'cancel'
    }]
}




// WEBPACK FOOTER //
// ./src/app/shared/services/email-sms-helper.ts